<template>
	<div class="franchise-page">
		<!-- banner -->
		<div class="section banner-box">
			<img :src="bannerList[0]?.img || require('@/assets/franchiseMb/banner.png')" alt="">
		</div>
		<div class="carousel-information" @click="openInquiryForm">
			<img src="../../assets/home/xinxi.png" alt="">
		</div>
		<!-- Section 2: Market Data -->
		<div class="section section2">
			<div class="market-title">
				<p>{{ pageData[0]?.value[0]?.title }}</p>
			</div>

			<div class="market-growth">
				<!-- <p>{{ $t('franchise.titleOneBold') }} {{ $t('franchise.titleOne') }}</p> -->
				<P>{{ pageData[0]?.value[0]?.subheading }}</P>
			</div>

			<div class="market-data">
				<div class="market-item" v-for="(item, index) in marketData.marketSize" :key="index">
					<div class="market-icon">
						<img :src="item.icon" alt=""></img>
					</div>
					<div class="market-info">
						<div class="market-label">{{ item.label }}</div>
						<div class="market-value">{{ item.value }} <span class="highlight">{{ item.amount }}</span> {{
							item.unit }}</div>
					</div>
				</div>
			</div>

			<div class="regional-pattern">
				<div class="regional-pattern-left">
					<!-- <h3>{{ $t('franchise.detailsRightOneText') }}</h3> -->
					<div class="regional-content">
						<div class="regional-text">
							<p>{{ $t('franchise.detailsRightOneTextNum') }}
								<span class="highlight"> {{ $t('franchise.detailsRightOneText2') }}</span>
							</p>
							<p>{{ $t('franchise.detailsRightOneText3') }}
								<!-- <span class="highlight-large">{{ marketData.regionalPattern.percentage }}</span> -->
							</p>
							<!-- <p>{{ $t('franchise.detailsRightOneText4') }}</p> -->
						</div>
					</div>
				</div>
				<div class="regional-pattern-right">
					<div class="pie-chart">
						<div class="regional-pie" id="regionalPieChart"></div>
					</div>
				</div>
			</div>

			<div class="scalp-issues">
				<h3>{{ $t('franchise.detailRightLeftChart.title') }}</h3>
				<div class="scalp-content">
					<div class="scalp-pie" id="scalpPieChart"></div>
				</div>

				<!-- <div class="market-description">
					<p>
						{{ $t('franchise.detailRightRightText') }}
						{{ $t('franchise.detailRightRightText2') }}
						{{ $t('franchise.detailRightRightText3') }}
						{{ $t('franchise.detailRightRightText4') }}
						{{ $t('franchise.detailRightRightText5') }}
					</p>
				</div> -->
			</div>
		</div>

		<!-- Section 3: Development History -->
		<div class="section section3">
			<div class="history-header">
				<h2>{{ pageData[1]?.value[0]?.title }}</h2>
				<h3>{{ pageData[1]?.value[0]?.subheading }}</h3>
			</div>

			<div class="timeline">
				<!-- developmentHistory.timeline -->
				<div class="timeline-item" v-for="(item, index) in pageData[1]?.value[0]?.content" :key="index">
					<div class="timeline-dot">
					</div>
					<div class="timeline-content">
						<div class="timeline-header">
							<div class="timeline-year">{{ item.year }}</div>
							<div class="timeline-tag">{{ item.subheading }}</div>
						</div>
						<div class="timeline-description">
							<!-- <div class="description-item" v-for="(desc, descIndex) in item.descriptions"
								:key="descIndex">
								<div class="bullet-point"></div>
								<p>{{ desc }}</p>
							</div> -->
							<div class="description-item" v-for="(paragraph, pIndex) in item.year_content" :key="pIndex">
								<p v-html="paragraph.year_content"></p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Section 4: Company's Future Plans -->
		<div class="section section4">
			<div class="future-header">
				<h2>{{ pageData[2]?.value[0]?.title }}</h2>
				<h3>{{ pageData[2]?.value[0]?.subheading }}</h3>
			</div>

			<div class="future-illustration">
				<img src="../../assets/franchiseMb/section4.png" alt="Future Plans Illustration">
			</div>

			<div class="future-content">
				<h4>{{ pageData[2]?.value[0]?.content_title }}</h4>
				<p class="future-description">
					{{ pageData[2]?.value[0]?.content_subheading }}
				</p>

				<div class="goals-list">
					<div class="goal-item" v-for="(goal, index) in pageData[2]?.value[0]?.content" :key="index">
						<div class="goal-number">{{ index + 1 }}</div>
						<div class="goal-text">
							<p>{{ goal.info }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Section 5: Contact Information -->
		<div class="section section5">
			<div class="contact-header">
				<h2>{{ pageData[3]?.value[0]?.title }}</h2>
				<h3>{{ pageData[3]?.value[0]?.subheading }}</h3>
			</div>

			<div class="contact-grid">
				<div class="contact-item" v-for="(country, index) in pageData[3]?.value[0]?.content" :key="index">
					<div class="contact-header-row">
						<div class="contact-icon">
							<img :src="country.icon" alt="">
						</div>
						<h4 class="contact-title">{{ country.contact_name }}</h4>
					</div>
					<p class="contact-website">
						<span class="contact-label">{{ $t('franchise.countries.label') }}</span>
						{{ country.official_url }}
					</p>
					<p class="contact-phone">
						<span class="contact-label">{{ $t('franchise.countries.label1') }}</span>
						{{ country.mobile }}
					</p>
				</div>

				<!-- <div class="contact-item coming-soon">
					<div class="coming-soon-icon">{{ contactInfo.comingSoon.icon }}</div>
					<div class="coming-soon-content">
						<p>{{ contactInfo.comingSoon.text }}</p>
					</div>
				</div> -->
			</div>
		</div>

		<!-- Section 6: Inquiry Form -->
		<div class="section section6">
			<div class="inquiry-header">
				<h2>{{ inquiryForm.title }}</h2>
			</div>


			<div class="section6-cont">
				<!-- <div class="form-group">
					<label class="form-label" for="exampleFormControlSelect1">{{ $t('home.inquiryCont.form.q1')
					}}</label>
					<el-select v-model="formData.question_type_id" :placeholder="$t('error.select')" style="width: 100%;">
						<el-option v-for="op in knowOPtions" :key="op.id" :label="op.name" :value="op.id">
						</el-option>
					</el-select>
				</div>
				<div class="form-group">
					<label class="form-label" for="exampleFormControlSelect1">{{ $t('home.inquiryCont.form.q2')
					}}</label>
					<el-select v-model="formData.body_option" :placeholder="$t('error.select')" style="width: 100%;">
						<el-option v-for="op in bodyOPtions" :key="op.value" :label="op.label" :value="op.value">
						</el-option>
					</el-select>
				</div> -->
				<div class="form-group">
					<label class="form-label" for="exampleFormControlInput1">{{ $t('content.follow.form.label.fullname') }}</label>
					<input type="text" class="form-control" v-model="formData.full_name"
						:placeholder="$t('home.inquiryCont.form.a3')">
				</div>
				<div class="form-group">
					<label class="form-label" for="exampleFormControlInput1">{{ $t('content.follow.form.label.contact') }}</label>
					<input type="text" class="form-control" v-model="formData.mobile"
						:placeholder="$t('home.inquiryCont.form.a4')">
				</div>
				<div class="form-group">
					<label class="form-label" for="exampleFormControlInput1">{{ $t('content.follow.form.label.email') }}</label>
					<input type="email" class="form-control" v-model="formData.email"
						:placeholder="$t('home.inquiryCont.form.a5')">
				</div>
				<div class="form-group">
					<label class="form-label" for="exampleFormControlInput1">{{ $t('home.inquiryCont.form.q6')
					}}</label>
					<input type="text" class="form-control" v-model="formData.preferred_city"
						:placeholder="$t('home.inquiryCont.form.a6')">
				</div>
				<div class="col-auto">
					<button type="submit" class="btn btn-dark mb-3 submit-button" @click.prevent="submit">{{ $t('content.follow.form.buttonText') }}</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { bus } from '@/utils/bus';
import { getDataList, getBannerListingMobile, getQuestionType, submitQuestion, getSolveOption } from '@/api/komo.js';
export default {
	data () {
		return {
			// Section 2: Market Data
			marketData: {
				marketSize: [
					{
						icon: require('@/assets/franchise/detailsLeftOne.png'),
						label: this.$t('franchise.detailsLeftOneText'),
						value: this.$t('franchise.detailsLeftTwoText'),
						amount: this.$t('franchise.detailsLeftTwoTextNum'),
						unit: this.$t('franchise.detailsLeftTwoText2')
					},
					{
						icon: require('@/assets/franchise/detailsLeftTwo.png'),
						label: this.$t('franchise.detailsLeftThreeText'),
						value: this.$t('franchise.detailsLeftTwoText'),
						amount: this.$t('franchise.detailsLeftFourTextNum'),
						unit: this.$t('franchise.detailsLeftTwoText2')
					}
				],
				regionalPattern: {
					title: this.$t('franchise.detailsRightOneText'),
					// description: [
					// 	"2024 The Asia Pacific region contributes globally",
					// 	"More than",
					// 	"market share"
					// ],
					// percentage: "40%",
					// legend: [
					// 	{ color: "asia-pacific-color", label: "亚太地区" },
					// 	{ color: "global-color", label: "全球市场" }
					// ]
				},
			},

			// Section 3: Development History
			developmentHistory: {
				title: this.$t('franchise.development.title'),
				subtitle: this.$t('franchise.development.title1'),
				timeline: [
					{
						year: "2010",
						tag: this.$t('franchise.timelineData.badge'),
						descriptions: [
							this.$t('franchise.timelineData.content'),
							this.$t('franchise.timelineData.contents')
						]
					},
					{
						year: "2020",
						tag: this.$t('franchise.timelineData.badge1'),
						descriptions: [
							this.$t('franchise.timelineData.content1')
						]
					},
					{
						year: "2025",
						tag: this.$t('franchise.timelineData.badge2'),
						descriptions: [
							this.$t('franchise.timelineData.content2'),
							this.$t('franchise.timelineData.contents2')
						]
					}
				]
			},

			// Section 4: Future Plans
			futurePlans: {
				title: this.$t('franchise.futurePlans.title'),
				subtitle: this.$t('franchise.futurePlans.title1'),
				illustration: "../../assets/franchiseMb/section4.png",
				mainGoal: this.$t('franchise.futurePlans.contH3'),
				description: this.$t('franchise.futurePlans.contP'),
				goals: [
					{
						number: "01",
						text: this.$t('franchise.futureGoals.content')
					},
					{
						number: "02",
						text: this.$t('franchise.futureGoals.content1')
					},
					{
						number: "03",
						text: this.$t('franchise.futureGoals.content2')
					}
				]
			},

			// Section 5: Contact Information
			contactInfo: {
				title: this.$t('franchise.countries.title'),
				subtitle: this.$t('franchise.countries.title1'),
				countries: [
					{
						name: this.$t('franchise.countriesData.name'),
						website: this.$t('franchise.countries.label') + ":" + this.$t('franchise.countriesData.website'),
						contact: this.$t('franchise.countries.label1') + "13800998800",
						icon: require("../../assets/franchiseMb/website.png")
					},
					{
						name: this.$t('franchise.countriesData.name4'),
						website: this.$t('franchise.countries.label') + ":" + this.$t('franchise.countriesData.website4'),
						contact: this.$t('franchise.countries.label1') + "13800998800",
						icon: require("../../assets/franchiseMb/website.png")
					},
					{
						name: this.$t('franchise.countriesData.name1'),
						website: this.$t('franchise.countries.label') + ":" + this.$t('franchise.countriesData.website1'),
						contact: this.$t('franchise.countries.label1') + "13800998800",
						icon: require("../../assets/franchiseMb/website.png")
					},
					{
						name: this.$t('franchise.countriesData.name2'),
						website: this.$t('franchise.countries.label') + ":" + this.$t('franchise.countriesData.website2'),
						contact: this.$t('franchise.countries.label1') + "13800998800",
						icon: require("../../assets/franchiseMb/website.png")
					},
					{
						name: this.$t('franchise.countriesData.name3'),
						website: this.$t('franchise.countries.label') + ":" + this.$t('franchise.countriesData.website3'),
						contact: this.$t('franchise.countries.label1') + "13800998800",
						icon: require("../../assets/franchiseMb/website.png")
					}
				],
				comingSoon: {
					text: "敬请期待~",
					icon: "💡"
				}
			},

			// Section 6: Inquiry Form
			inquiryForm: {
				title: "Inquiry",
				fields: {
					inquiry: {
						label: "What do you want to know?",
						placeholder: "Investment promotion",
						type: "select",
						options: ["Investment promotion", "Product information", "Partnership", "Technical support"]
					},
					bodyOptions: {
						label: "Body Options:",
						placeholder: "Franchisee",
						type: "select",
						options: ["Franchisee", "Investor", "Partner", "Individual"]
					},
					fullName: {
						label: "Full Name:",
						placeholder: "Enter",
						type: "text"
					},
					contactInfo: {
						label: "Contact Information:",
						placeholder: "Call back within 24 hours",
						type: "text"
					},
					email: {
						label: "E-mail:",
						placeholder: "Used for accepting franchise proposals",
						type: "email"
					},
					intendedCity: {
						label: "Intended City:",
						placeholder: "Preferred City",
						type: "text"
					}
				},
				submitButton: "Submit Now",
				note: "Note: Once the form is completed, one set of franchise application will be automatically obtained and sent to the email within 48 hours"
			},

			// Form data
			knowOPtions: [],
			bodyOPtions: this.$t('content.follow.identityOPtions'),
			checkOptions: [],
			formData: {
				// question_type_id: '',
				// body_option: '',
				full_name: '',
				mobile: '',
				email: '',
				preferred_city: '',
				// problem: []
			},
			bannerList: [],
			pageData: []
		}
	},
	async created () {
		this.initData();
	},
	mounted () {
		this.initRegionalPieChart();
		this.initScalpPieChart();
	},
	methods: {
		openInquiryForm(){
      bus.$emit('inquiry-form', true)
    },
		async initData () {
			const res = await getBannerListingMobile('8')
			if (res.error == 0) {
				this.bannerList = res?.data?.list || [];
			}

			const res1 = await getDataList(localStorage?.getItem('pageId'))
			this.pageData = res1?.data?.list || []

			getQuestionType().then(res => {
				this.knowOPtions = res?.data?.list
			})
			getSolveOption().then(res => {
				this.checkOptions = res?.data?.list
			})
		},
		async submit () {
			console.log('1111')
			// if (!this.formData.question_type_id) {
			// 	this.$message.error(this.$t('error.select'))
			// 	return;
			// }
			// // 校验身份
			// if (this.formData.body_option === '' || this.formData.body_option == null) {
			// 	this.$message.error(this.$t('error.select'))
			// 	return;
			// }
			// 校验名字
			if (!this.formData.full_name) {
				this.$message.error(this.$t('error.name'))
				return;
			}
			// 校验手机号
			if (!this.formData.mobile) {
				this.$message.error(this.$t('error.phone'))
				return;
			}
			if (!this.validatePhone(this.formData.mobile)) {
				this.$message.error(this.$t('error.phoneFormat'))
				return;
			}
			// 校验邮箱
			if (!this.formData.email) {
				this.$message.error(this.$t('error.email'))
				return;
			}
			if (!this.validateEmail(this.formData.email)) {
				this.$message.error(this.$t('error.emailFormat'))
				return;
			}
			// 校验意向地址
			if (!this.formData.preferred_city) {
				this.$message.error(this.$t('error.name'))
				return;
			}

			const params = {
				// question_type_id: this.formData.question_type_id,
				// body_option: this.formData.body_option === 0 ? "consumer" : "franchisee",
				body_option: "franchisee",
				full_name: this.formData.full_name,
				mobile: this.formData.mobile,
				email: this.formData.email,
				preferred_city: this.formData.preferred_city,
				// problem: this.formData.problem
			}
			// console.log('submit123', params)
			const res = await submitQuestion(params)
			if (res?.error === 0) {
				this.$message.success(res?.message)
				//提交成功 重置表单
        this.formData =  {
          full_name: '',
					mobile: '',
					email: '',
					preferred_city: '',
        }
			} else {
				this.$message.error(res?.message)
			}

		},
		//验证手机号格式
		validatePhone (phone) {
			// 验证手机号是否为纯数字
			const numberRegex = /^1[34578]\d{9}$/;
			return numberRegex.test(phone);
		},
		//验证邮箱格式
		validateEmail (email) {
			const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
			return emailRegex.test(email);
		},
		// 获取顶部banne数据
		async getBannerData () {
			const res = await getBannerListing('8')
			if (res.error == 0) {
				this.bannerList = res?.data?.list || [];
			}
		},
		// 获取页面数据
		async getDataList () {
			const res = await getDataList(localStorage?.getItem('pageId'))
			this.pageData = res?.data?.list || []
		},
		// Regional Pie Chart
		initRegionalPieChart () {
			const regionalPieChart = this.$echarts.init(document.getElementById('regionalPieChart'));
			const option = {
				tooltip: {
					trigger: 'item'
				},
				legend: {
					bottom: '0',
					left: 'center',
					icon: 'circle', // 统一设置为圆点
					textStyle: {
						fontSize: 10
					},
				},
				series: [
					{
						name: this.$t('franchise.detailsRightChartText'),
						type: 'pie',
						radius: ['40%', '70%'],
						center: ['50%', '40%'],
						avoidLabelOverlap: false,
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: false,
								fontSize: 40,
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: [
							{ value: 400, name: this.$t('franchise.detailsRightChartDataText') },
							{ value: 1200, name: this.$t('franchise.detailsRightChartDataText1') },
						],
						itemStyle: {
							color: function (params) {
								// 自定义颜色逻辑
								const colorList = ['#FF4757', '#d5dcc8']; // 颜色数组
								return colorList[params.dataIndex];
							}
						},
					}
				]
			};
			regionalPieChart.setOption(option);
		},
		// Scalp Pie Chart
		initScalpPieChart () {
			const scalpPieChart = this.$echarts.init(document.getElementById('scalpPieChart'));
			const option = {
				tooltip: {
					trigger: 'item'
				},
				legend: {
					orient: 'vertical',
					top: 'center',
					left: '0',
					icon: 'circle', // 统一设置为圆点
					// textStyle: {
					// 	fontSize: 16
					// },
					// itemGap: 'auto',
					// itemGap: 20
				},
				series: [
					{
						name: this.$t('franchise.detailRightLeftChart.title'),
						type: 'pie',
						radius: ['40%', '70%'],
						center: ['70%', '50%'],
						avoidLabelOverlap: false,
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: false,
								fontSize: 40,
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: [
							{ value: 1200, name: this.$t('franchise.detailRightLeftChart.legend') },
							{ value: 1000, name: this.$t('franchise.detailRightLeftChart.legend1') },
							{ value: 500, name: this.$t('franchise.detailRightLeftChart.legend2') },
							{ value: 200, name: this.$t('franchise.detailRightLeftChart.legend3') },
							{ value: 100, name: this.$t('franchise.detailRightLeftChart.legend4') },
							{ value: 50, name: this.$t('franchise.detailRightLeftChart.legend5') },
						],
						itemStyle: {
							color: function (params) {
								// 自定义颜色逻辑
								const colorList = ['#709df4', '#70dbad', '#72829c', '#f4c433', '#e87b5f', '#80cde9']; // 颜色数组
								return colorList[params.dataIndex];
							}
						},
					}
				]
			};
			scalpPieChart.setOption(option);
		},
		submitForm () {
			// 表单提交逻辑
			console.log('Form submitted:', this.formData);
			// 这里可以添加表单验证和提交到服务器的逻辑
		}
	},
}
</script>
<style scoped>
.franchise-page {
	overflow-x: hidden;
}

.banner-box {
	width: 100%;
}

.banner-box img {
	width: 100%;
}
.carousel-information {
	position: fixed;
    bottom: 3%;
    right: 3%;
    width: 25vw;
    height: 25vw;
    cursor: pointer;
    z-index: 999;
}
.carousel-information img {
	width: 100%;
	height: 100%;
}
/* Section 2 - Market Data */
.section2 {
	background-color: #FBF7EB;
	padding: 10.67vw 3.2vw;
}

.market-title p {
	font-size: 6vw;
	font-weight: bold;
	color: #333;
	text-align: center;
	margin: 0 0 6.4vw 0;
	line-height: 1.2;
}

.market-growth {
	text-align: center;
	margin-bottom: 3vw;
}

.market-growth p {
	font-size: 3.73vw;
	color: #666;
	margin: 0;
	line-height: 1.5;
}

.market-growth strong {
	color: #333;
	font-weight: bold;
}

.market-data {
	margin-bottom: 3vw;
	border-radius: 2.67vw;
	background-color: #D4DDC6;
	padding: 5.33vw 5.87vw;
}

.market-item {
	display: flex;
	align-items: center;
}

.market-item:last-child {
	margin-top: 4.53vw;
}

.market-icon {
	width: 15%;
	height: 15%;
	margin-right: 4.27vw;
}

.market-icon img {
	width: 100%;
	height: 100%;
}

.market-info {
	flex: 1;
}

.market-label {
	font-size: 3.2vw;
	color: #666;
}

.market-value {
	font-size: 3vw;
	color: #333;
	font-weight: 500;
}

.highlight {
	color: #FF4757;
	font-weight: bold;
	font-size: 4vw;
}

.regional-pattern {
	margin-bottom: 3vw;
	background-color: #e8e9d9;
	border-radius: 2.67vw;
	padding: 5.33vw;
	display: flex;
	flex-direction: row;
}

.regional-pattern-left {
	width: 50%;
	height: 100%;
}

.regional-pattern-right {
	width: 50%;
	height: 100%;
}

.pie-chart {
	width: 100%;
	height: 30vw;
	position: relative;
	margin-bottom: 3.2vw;
}


.regional-pie {
	width: 100%;
	height: 100%;
}

.regional-pattern h3 {
	font-size: 4vw;
	color: #64715D;
	margin: 0 0 5.33vw 0;
	font-weight: bold;
}

.regional-content {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 4vw;
}

.regional-text {
	flex: 1;
}

.regional-text p {
	font-size: 3vw;
	color: #333;
	margin: 0 0 1.07vw 0;
	line-height: 1.4;
	font-weight: 500;
}

.regional-text p:last-child {
	margin-bottom: 0;
}

.highlight-large {
	color: #FF4757;
	font-weight: bold;
	font-size: 5vw;
}


.asia-pacific-color {
	background-color: #FF4757;
}

.global-color {
	background-color: #D0D7C4;
}

.scalp-issues {
	background-color: #e8e9d9;
	border-radius: 2.67vw;
	padding: 5.33vw;
}

.scalp-issues h3 {
	font-size: 4.8vw;
	color: #64715D;
	margin: 0 0 5.33vw 0;
	font-weight: bold;
}

.scalp-content {
	/* display: flex;
	align-items: flex-start;
	justify-content: space-between;
	margin-bottom: 6.4vw;
	gap: 4.27vw; */
	width: 100%;
	height: 50vw;
}

.scalp-chart {
	flex-shrink: 0;
}

.scalp-pie {
	width: 100%;
	height: 100%;
	padding: 0 2vw;
}

/* .scalp-pie {
	width: 32vw;
	height: 32vw;
	background: conic-gradient(#4A90E2 0deg 120deg,
			#7ED321 120deg 200deg,
			#6B73FF 200deg 250deg,
			#F5A623 250deg 280deg,
			#FF6B6B 280deg 310deg,
			#50E3C2 310deg 360deg);
	border: 0.53vw solid #fff;
	box-sizing: border-box;
	box-shadow: 0 0.53vw 2.67vw rgba(0, 0, 0, 0.1);
} */

.scalp-legend {
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 2.67vw;
}

.scalp-legend .legend-item {
	font-size: 3.2vw;
	color: #333;
	font-weight: 500;
}

.scalp-legend .legend-color {
	width: 3.2vw;
	height: 3.2vw;
	border-radius: 50%;
	margin-right: 2.67vw;
	border: 0.27vw solid #fff;
	box-shadow: 0 0.27vw 0.8vw rgba(0, 0, 0, 0.15);
}

.anti-dandruff {
	background-color: #4A90E2;
}

.hair-loss {
	background-color: #7ED321;
}

.white-hair {
	background-color: #6B73FF;
}

.short-tempered {
	background-color: #F5A623;
}

.itchy {
	background-color: #FF6B6B;
}

.other {
	background-color: #50E3C2;
}

.market-description {
	background: transparent;
	border-radius: 0;
	padding: 0;
	margin-top: 2.67vw;
}

.market-description p {
	font-size: 3.73vw;
	color: #333;
	line-height: 1.5;
	margin: 0;
	font-weight: 500;
}

/* Section 3 - Development History */
.section3 {
	background-color: #F8F9FC;
	padding: 10.67vw 6.67vw;
}

.history-header {
	text-align: center;
	margin-bottom: 10.67vw;
}

.history-header h2 {
	font-size: 6.4vw;
	font-weight: bold;
	color: #333;
	margin: 0 0 2.67vw 0;
	line-height: 1.2;
}

.history-header h3 {
	font-size: 4.27vw;
	color: #666;
	margin: 0;
	font-weight: normal;
}

.timeline {
	position: relative;
}

.timeline::before {
	content: '';
	position: absolute;
	left: 2.67vw;
	top: 1.33vw;
	bottom: 0;
	width: 0.53vw;
	background-color: #E0E0E0;
}

.timeline-item {
	position: relative;
	margin-bottom: 8vw;
	padding-left: 11.73vw;
}

.timeline-item:last-child {
	margin-bottom: 0;
}

.timeline-dot {
	position: absolute;
	left: 1.33vw;
	top: 1.33vw;
	width: 3vw;
	height: 3vw;
	background-color: #64715D;
	border-radius: 50%;
	z-index: 2;
	display: flex;
	justify-content: center;
	align-items: center;
	outline: 1.07vw solid #D5DCC8;
}


.timeline-content {
	border-radius: 2.67vw;
	position: relative;
}

.timeline-header {
	display: flex;
	align-items: center;
	margin-bottom: 3.2vw;
}

.timeline-year {
	font-size: 5.33vw;
	font-weight: bold;
	color: #64715D;
	margin: 0;
	margin-right: 2.13vw;
}

.timeline-tag {
	background-color: #D5DCC8;
	color: #1E1E1E;
	font-size: 3.2vw;
	padding: 1.33vw 2.67vw;
	border-radius: 4vw;
	margin: 0;
	font-weight: 500;
	flex-shrink: 0;
}

.timeline-description {
	margin-top: 4.27vw;
	background-color: #fff;
	padding: 3.2vw;
	border-radius: 2.67vw;
}

.description-item {
	display: flex;
	align-items: flex-start;
	margin-bottom: 3.2vw;
}

.description-item:last-child {
	margin-bottom: 0;
}

.bullet-point {
	width: 2.67vw;
	height: 2.67vw;
	background-color: #D5DCC8;
	border-radius: 50%;
	margin-right: 2.67vw;
	margin-top: 1.6vw;
	flex-shrink: 0;
	outline: 0.53vw solid #64715D;
}

/* Section 4 - Company's Future Plans */
.section4 {
	background-color: #D5DCC8;
	padding: 10.67vw 3.2vw;
}

.future-header {
	text-align: center;
	margin-bottom: 8vw;
}

.future-header h2 {
	font-size: 6.4vw;
	font-weight: bold;
	color: #333;
	margin: 0 0 2.67vw 0;
	line-height: 1.2;
}

.future-header h3 {
	font-size: 4.27vw;
	color: #666;
	margin: 0;
	font-weight: normal;
}

.future-illustration {
	text-align: center;
	margin-bottom: 8vw;
	border-radius: 2.67vw;
}

.future-illustration img {
	width: 100%;
	height: auto;
}

.future-content h4 {
	font-size: 5.33vw;
	font-weight: bold;
	color: #64715D;
	margin: 0 0 4.27vw 0;
	text-align: left;
}

.future-description {
	font-size: 3.73vw;
	color: #666;
	line-height: 1.5;
	margin: 0 0 8vw 0;
	text-align: left;
}

.goals-list {
	display: flex;
	flex-direction: column;
	gap: 5.33vw;
}

.goal-item {
	display: flex;
	align-items: flex-start;
	gap: 4.27vw;
}

.goal-number {
	width: 8vw;
	height: 8vw;
	background-color: #1E1E1E;
	color: white;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 3.73vw;
	font-weight: bold;
	flex-shrink: 0;
	margin-top: 0.53vw;
}

.goal-text {
	flex: 1;
}

.goal-text p {
	font-size: 3.73vw;
	color: #333;
	line-height: 1.5;
	margin: 0;
}

/* Section 5 - Contact Information */
.section5 {
	background-color: #F8F9FC;
	padding: 10.67vw 3.2vw;
}

.contact-header {
	text-align: center;
	margin-bottom: 8vw;
}

.contact-header h2 {
	font-size: 6.4vw;
	font-weight: bold;
	color: #333;
	margin: 0 0 2.67vw 0;
	line-height: 1.2;
}

.contact-header h3 {
	font-size: 4.27vw;
	color: #666;
	margin: 0;
	font-weight: normal;
}

.contact-grid {
	display: flex;
	grid-template-columns: 1fr 1fr;
	gap: 4.27vw;
	flex-direction: column;
}

.contact-item {
	background: rgba(255, 255, 255, 0.9);
	border-radius: 2.67vw;
	padding: 4vw;
	display: flex;
	flex-direction: column;
	min-height: 24vw;
}

.contact-header-row {
	display: flex;
	align-items: center;
	gap: 3.2vw;
	margin-bottom: 2.67vw;
}

.contact-icon {
	width: 7.47vw;
	height: 7.47vw;
	display: flex;
	align-items: center;
	justify-content: center;
}

.contact-icon img {
	width: 100%;
	height: 100%;
}

.contact-title {
	font-size: 4.27vw;
	font-weight: bold;
	color: #333;
	margin: 0;
	line-height: 1.2;
	flex: 1;
}

.contact-website {
	font-size: 3.2vw;
	color: #666;
	margin: 0 0 1.33vw 0;
	line-height: 1.3;
}

.contact-label {
	color: #959595;
	margin-right: 2%;
	white-space: nowrap;
}

.contact-phone {
	font-size: 3.2vw;
	color: #666;
	margin: 0;
	line-height: 1.3;
}

.coming-soon {
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
	gap: 0;
}

.coming-soon-icon {
	width: 10.67vw;
	height: 10.67vw;
	background-color: rgba(160, 160, 160, 0.2);
	border-radius: 2.67vw;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 5.33vw;
	margin-bottom: 2.67vw;
}

.coming-soon-content p {
	font-size: 3.73vw;
	color: #999;
	margin: 0;
	line-height: 1.2;
}

/* Section 6 - Inquiry Form */
.section6 {
	background-color: #fff;
	padding: 10.67vw 3.2vw;
}

.inquiry-header {
	text-align: center;
	margin-bottom: 8vw;
}

.inquiry-header h2 {
	font-size: 6.4vw;
	font-weight: bold;
	color: #333;
	margin: 0;
	line-height: 1.2;
}

.inquiry-form {
	max-width: 100%;
}

.form-group {
	margin-bottom: 5.33vw;
}

/* .form-group label {
	display: block;
	font-size: 3.73vw;
	color: #333;
	margin-bottom: 2.67vw;
	font-weight: 500;
} */

/* .form-input,
.form-select {
	width: 100%;
	padding: 4.27vw;
	border: 0.27vw solid #E0E0E0;
	border-radius: 2.67vw;
	font-size: 3.73vw;
	color: #333;
	background-color: #fff;
	box-sizing: border-box;
	outline: none;
	transition: border-color 0.3s ease;
} */

.form-input:focus,
.form-select:focus {
	border-color: #4A90E2;
}

/* .form-input::placeholder {
	color: #999;
	font-size: 3.73vw;
} */

/* .form-select {
	appearance: none;
	background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");
	background-repeat: no-repeat;
	background-position: right 3.2vw center;
	background-size: 4.27vw;
	padding-right: 10.67vw;
	cursor: pointer;
}

.form-select option {
	padding: 2.67vw;
	font-size: 3.73vw;
} */
.section6-cont{
	display: flex;
  flex-direction: column;
  gap: 0.5vh;	
}
.submit-button {
	/* width: 100%;
	padding: 4.27vw;
	background-color: #333;
	color: #fff;
	border: none;
	border-radius: 10.67vw;
	font-size: 4.27vw;
	font-weight: bold;
	cursor: pointer;
	margin-bottom: 5.33vw;
	transition: background-color 0.3s ease; */
	width: 22vh;
  padding: 2vw 3vw;
  background-color: #333;
  color: #fff;
  border: none;
  border-radius: 10.67vw;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.submit-button:hover {
	background-color: #555;
}

.submit-button:active {
	background-color: #222;
}

.form-note {
	font-size: 3.2vw;
	color: #999;
	line-height: 1.5;
	margin: 0;
	text-align: left;
}

.description-item p {
	font-size: 3.2vw;
	color: #666;
	line-height: 1.5;
	margin: 0;
	flex: 1;
}
</style>
